export default __webpack_public_path__ + "static/media/dropoff.2d466b05.svg";